<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :label-width="'100px'"
      :search-btn-span="24"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      :before-reset-search="beforeResetSearch"
      :tooltip-config="{ showAll: false, enterable: false }"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <!-- 采购单号 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseComponentsCom.PO.code')" prop="code">
            <BjInputCode
              v-model="queryParams.code"
              :placeholder="$t('BusinessPurchaseComponentsCom.PO.code')"
              comma
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <!-- 采购申请单号 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrderList.requisition')" prop="applyCode">
            <BjInputCode
              v-model="queryParams.applyCode"
              :placeholder="$t('BusinessPurchaseOrderList.requisition')"
              comma
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <!-- 采购类型 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrderList.type')" prop="type">
            <BjSelectLov v-model="queryParams.purchaseType" :placeholder="$t('BusinessPurchaseOrderList.type')" lov-code="SPUR.PURCHASE_TYPE" />
          </el-form-item>
        </el-col>
        <!-- 采购单状态 -->
        <!-- <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrderList.status')" prop="status">
            <BjSelectLov v-model="queryParams.status" :option-list="EXEC_STATUS_LIST" />
          </el-form-item>
        </el-col> -->
        <!-- SKU编码 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrderList.code')" prop="skuCode">
            <BjInputCode
              v-model="queryParams.skuCode"
              :placeholder="$t('BusinessPurchaseOrderList.code')"
              comma
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrderList.table.Buyer')">
            <BjInput v-model="queryParams.buyerName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BusinessPurchaseOrderList.table.Buyer')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <!-- 创建时间 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrderList.Creation')">
            <BjDateTimerangePicker v-model="queryParamsTime_postingDate" :placeholder="$t('BusinessPurchaseOrderList.Creation')" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:seniorForm>
        <!-- 预计到货时间 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrderList.delivery')">
            <BjDateTimerangePicker v-model="queryParamsTime_expectedDate" :placeholder="$t('BusinessPurchaseOrderList.delivery')" />
          </el-form-item>
        </el-col>
        <!-- 完成日期 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrderList.Completion')">
            <BjDateTimerangePicker v-model="queryParamsTime_finishTime" :placeholder="$t('BusinessPurchaseOrderList.Completion')" />
          </el-form-item>
        </el-col>
        <!-- 生成日期 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrderList.Generation')">
            <BjDateTimerangePicker v-model="queryParamsTime_documentDate" :placeholder="$t('BusinessPurchaseOrderList.Generation')" />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="colSpan">
          <div style="width:30px;height: 10px;"> </div>
        </el-col> -->
        <!-- css空壳 -->
        <!-- <el-col :span="colSpan">
          <div style="width:30px;height: 10px;"> </div>
        </el-col> -->
      </template>
      <template v-slot:tableOperation>
        <BjFrontendExport
          :disabled="!selectedRows.length"
          class="ml5"
          type="primary"
          :label-list="exportLabelList"
          :get-rows="getExportRows"
          file-name="Purchase Orders.xls"
          worksheet="worksheet1"
        />
      </template>
      <!-- 展示列表 -->
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'"
          :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
          :prop="col.prop"
          :label="col.label"
          :width="col.width || 'auto'"
          :fixed="col.fixed || false"
          align="center"
          class-name="item"
          :show-overflow-tooltip="col.prop !== 'bjTableAction'">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'code'">
                <span class="link" @click="onLook(scope.row)">{{ scope.row[col.prop] }}</span>
                <BjCopyIcon :copy="scope.row[col.prop]" />
              </template>
              <template v-else-if="col.prop === 'applyCode'">
                <span class="link">{{ scope.row[col.prop] }}</span>
                <BjCopyIcon :copy="scope.row[col.prop]" />
              </template>
              <!-- <template v-else-if="col.prop === 'purchaseLabels'">
                <BjTagList :tag-code-array="scope.row[col.prop]" size="mini" />
              </template> -->
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <!-- 查看 -->
              <el-button type="text" class="view-btn" @click="onLook(props.row)">{{ $t('BusinessPurchaseOrderList.View') }}</el-button>
              <!-- 操作 下拉选择下一步操作 -->
<!--              <el-dropdown v-if="props.row.status != 'CANCELLED'" v-hasDropdownChildren size="mini" @command="command($event, props.row)">-->
<!--                <span class="el-dropdown-link">{{ $t('AccountManagement.common.operate') }}<i class="el-icon-arrow-down el-icon&#45;&#45;right" /></span>-->
<!--                <el-dropdown-menu slot="dropdown">-->
<!--                  &lt;!&ndash; 采购单生产 &ndash;&gt;-->
<!--                  <el-dropdown-item :disabled="props.row.status=='IN_PROD'" :command="$t('BusinessPurchaseOrderList.production')">{{ $t('BusinessPurchaseOrderList.production') }}</el-dropdown-item>-->
<!--                  &lt;!&ndash; 数据容错 &ndash;&gt;-->
<!--                  <el-dropdown-item :disabled="!props.row.status=='IN_PROD'" :command="$t('BusinessPurchaseOrderList.tolerance')">{{ $t('BusinessPurchaseOrderList.tolerance') }}</el-dropdown-item>-->
<!--                  &lt;!&ndash; 完成采购 &ndash;&gt;-->
<!--                  <el-dropdown-item :disabled="!props.row.status=='IN_PROD'" :command="$t('BusinessPurchaseOrderList.over')">{{ $t('BusinessPurchaseOrderList.over') }}</el-dropdown-item>-->
<!--                  &lt;!&ndash; 废弃 &ndash;&gt;-->
<!--                  <el-dropdown-item :disabled="props.row.status!='WAIT_PRODUCED'" :command="$t('BusinessPurchaseOrderList.Abandoned')">{{ $t('BusinessPurchaseOrderList.Abandoned') }}</el-dropdown-item>-->
<!--                </el-dropdown-menu>-->
<!--              </el-dropdown>-->
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 侧边栏弹窗 -->
    <DataForm ref="DataForm" @reFresh="reFresh" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { purchaseApi, tagsApi } from '@/api';
import {
  PURCHASELIST_STATUS_LIST,
  EXEC_STATUS_LIST
} from '@/utils/constants';
import DataForm from './DataForm.vue';
export default {
  name: 'BusinessPurchaseOrder',
  components: { DataForm },
  mixins: [pageMiXin],
  props: {
    businessType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selection: true,
      // colSpan: 6,
      PURCHASE_LABEL: [],
      PURCHASELIST_STATUS_LIST,
      EXEC_STATUS_LIST,

      // 查询参数
      queryApi: purchaseApi.getPurchases,
      queryParamsTime_postingDate: [],
      queryParamsTime_expectedDate: [],
      queryParamsTime_finishTime: [],
      queryParamsTime_documentDate: [],
      queryParams: {
        businessType: this.businessType,
        channel: null,
        buyerName: null,
        purchaseType: null,
        code: null,
        applyCode: null,
        status: null,
        purchaseLabel: null,
        type: null,
        skuCode: null,
        creationDateBegin: null,
        creationDateEnd: null,
        expectedDateBegin: null,
        expectedDateEnd: null,
        finishTimeBegin: null,
        finishTimeEnd: null,
        documentDateBegin: null,
        documentDateEnd: null,
      },
      labelsVersion: 13,
      skuDetails: [], // 临时存放sku商品的明细信息
      labelList: [
        { label: this.$t('BusinessPurchaseComponentsCom.PO.code'), prop: 'code', isCheck: true, disabled: false, width: '175' },
        { label: this.$t('BusinessPurchaseOrderList.table.requisition'), prop: 'applyCode', isCheck: true, disabled: false, width: '198' },
        { label: this.$t('BusinessPurchaseOrderList.contract'), prop: 'thirdCode', isCheck: true, disabled: false, width: '165' },
        { label: this.$t('BusinessPurchaseOrderList.source'), prop: 'source', isCheck: true, disabled: false, width: '140' },
        { label: this.$t('BusinessPurchaseOrderList.shippingCountry'), prop: 'countryCode', isCheck: true, disabled: false, width: '152' },
        { label: this.$t('BusinessPurchaseOrderList.type'), prop: 'typeMeaning', isCheck: true, disabled: false },
        // { label: this.$t('BusinessPurchaseOrderList.taxCode'), prop: 'taxCode', isCheck: true, disabled: false, width: '80' },
        // { label: this.$t('BusinessPurchaseOrderList.table.status'), prop: 'status', isCheck: true, disabled: false, width: '156' },
        // { label: this.$t('BusinessPurchaseOrderList.table.label'), prop: 'purchaseLabels', isCheck: true, disabled: false, width: '143' },
        { label: this.$t('BusinessPurchaseOrderList.table.Buyer'), prop: 'buyerName', isCheck: true, disabled: false },
        { label: this.$t('BusinessPurchaseOrderList.table.Creation'), prop: 'creationDate', isCheck: true, disabled: false, width: '160' },
        { label: this.$t('BusinessPurchaseOrderList.table.arrival'), prop: 'expectedDate', isCheck: true, disabled: false, width: '160' },
        // { label: this.$t('BusinessPurchaseOrderList.table.Completion'), prop: 'finishTime', isCheck: true, disabled: false, width: '160' },
        { label: this.$t('BusinessPurchaseOrderList.table.Generation'), prop: 'documentDate', isCheck: true, disabled: false, width: '160' },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: '120' },
      ],
      exportLabelList: [
        { label: this.$t('BusinessPurchaseOrderList.code'), prop: 'skuCode' },
        { label: this.$t('BusinessPurchaseDetailPage.table.Purchase'), prop: 'qty' },
        { label: this.$t('BusinessPurchaseDetailPage.table.Australian'), prop: 'auPurchasePrice' },
        { label: this.$t('BusinessPurchaseApply.cnPurchasePrice'), prop: 'cnPurchasePrice' },
        { label: this.$t('BusinessPurchaseOrderList.contract'), prop: 'thirdCode' },
        { label: this.$t('BusinessPurchaseDetailPage.table.Actual'), prop: 'actualProfitRate' },
        { label: this.$t('BusinessPurchaseDetailPage.table.Product1'), prop: 'category' },
        { label: this.$t('BusinessPurchaseDetailPage.Creation'), prop: 'creationDate' },
      ],
    };
  },
  computed: { },
  watch: {
    // 创建时间
    queryParamsTime_postingDate(v) {
      this.queryParams.creationDateBegin = (v || [])[0];
      this.queryParams.creationDateEnd = (v || [])[1];
    },
    // 预计到货时间
    queryParamsTime_expectedDate(v) {
      this.queryParams.expectedDateBegin = (v || [])[0];
      this.queryParams.expectedDateEnd = (v || [])[1];
    },
    // 完成日期
    queryParamsTime_finishTime(v) {
      this.queryParams.finishTimeBegin = (v || [])[0];
      this.queryParams.finishTimeEnd = (v || [])[1];
    },
    // 生成日期
    queryParamsTime_documentDate(v) {
      this.queryParams.documentDateBegin = (v || [])[0];
      this.queryParams.documentDateEnd = (v || [])[1];
    },
  },
  mounted() {
    this.getSkuTagList();
  },
  methods: {
    // 获取采购单标签
    getSkuTagList() {
      const data = {
        labelType: 9,
        systemLabelFlag: false,
        pageSize: 40
      };
      tagsApi.getLabels(data).then(res => {
        if (!res.content.length) return;
        this.PURCHASE_LABEL = res.content.map(item => {
          return {
            label: item.textContent,
            value: item.labelCode
          };
        });
      });
    },
    async getExportRows() {
      const tableData = [];
      for (const row of this.selectedRows) {
        const skuCodeList = row.goodsList.map(item => item.skuCode);
        await this.getSkuDetails(skuCodeList);
        for (const item of row.goodsList) {
          tableData.push({
            'skuCode': item.skuCode,
            'qty': item.planQty,
            'auPurchasePrice': item.auPurchasePrice,
            'cnPurchasePrice': item.cnPurchasePrice,
            'thirdCode': row.thirdCode,
            'actualProfitRate': item.actualProfitRate,
            'category': await this.getCurrentSkuDetail(item.skuCode, 'categoryStr'),
            'creationDate': row.creationDate
          });
        }
      }
      return tableData;
    },
    // 获取导出商品的明细信息
    async getSkuDetails(code) {
      const res = await purchaseApi.purchaseGoodsImport(code);
      if (!res.length) return;
      this.skuDetails = res;
    },
    // 获取每一项商品的 分类
    async getCurrentSkuDetail(skuCode, key) {
      return new Promise(resolve => {
        let data = '';
        const items = this.skuDetails.find(item => item.skuCode === skuCode);
        if (items) {
          data = items[key];
        } else {
          data = '';
        }
        resolve(data);
      });
    },
    // 查看采购单详情。
    onLook(r) {
      this.$router.push({
        name: 'BusinessPurchaseDetail',
        query: {id: r.id, code: r.code},
      });
    },
    // 操作下拉菜单
    command(TEXT, r) {
      if (TEXT === this.$t('BusinessPurchaseOrderList.production')) {
        this.onProduction(r);
        return;
      }
      if (TEXT === this.$t('BusinessPurchaseOrderList.tolerance')) {
        this.onTolerance(r);
        return;
      }
      if (TEXT === this.$t('BusinessPurchaseOrderList.over')) {
        this.onFinish(r);
        return;
      }
      if (TEXT === this.$t('BusinessPurchaseOrderList.Abandoned')) {
        this.onDiscard(r);
        return;
      }
    },

    // 采购单生产按钮
    onProduction(r) {
      const data = {
        ids: [{ id: r.id, objectVersionNumber: r.objectVersionNumber }],
        status: 'IN_PROD',
      };
      // 接口：采购单生产（状态）
      purchaseApi.purchaseChangeStatus(data).then(res => {
            if (!res.failed) {
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              setTimeout(() => {
                this.reFresh();
              }, 500);
            }
      });
    },

    // 数据容错，弹出侧边栏操作
    onTolerance(r) {
      this.$refs.DataForm.show(r);
    },

    // 完成采购按钮
    onFinish(r) {
      const data = { code: r.code };
      // 接口：完成采购
      purchaseApi.purchaseFinish(data).then(res => {
            if (!res.failed) {
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              setTimeout(() => {
                this.reFresh();
              }, 500);
            }
      });
    },

    // 废弃按钮
    onDiscard(r) {
      const data = {
        ids: [{ id: r.id, objectVersionNumber: r.objectVersionNumber}]
      };
      // 接口：废弃采购单
      purchaseApi.purchaseCancel(data).then(res => {
            if (!res.failed) {
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              setTimeout(() => {
                this.reFresh();
              }, 500);
            }
      });
    },

    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime_postingDate = null;
      this.queryParamsTime_expectedDate = null;
      this.queryParamsTime_finishTime = null;
      this.queryParamsTime_documentDate = null;
      this.queryParams.purchaseType = null;
      this.queryParams.buyerName = null;
      return new Promise(resolve => {
        resolve();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-icon-s-flag {
  float: right;
  line-height: 34px;
}
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
